import React from "react";
import "../Eventlist/Eventlist.css";

function Eventlist() {
  return (
    <div className="eventlis">
      <div className="eventlist-header">
        <h1>Upcoming Events</h1>
        <div className="event-add-btn">
          <button>+</button>
        </div>
      </div>
      <div className="eventlist-date-type">
        <div className="event-dt-dev">
          <div className="dt-left">
            <div className="dt-left-left">
              <span className="day">Oct</span>
              <span className="day">Mon</span>
            </div>
            <div className="dt-left-right">
              <span className="month">
                2 <sup>nd</sup>
              </span>
            </div>
          </div>
          <div className="dt-right">
            <h3 className="event-name">Gandhi Jayanti</h3>
            <p className="event-description">
              A national holiday in India that honors the birth of Mahatma
              Gandhi.
            </p>
          </div>
        </div>
        <div className="event-dt-dev">
          <div className="dt-left">
            <div className="dt-left-left">
              <span className="day">Oct</span>
              <span className="day">Sat</span>
            </div>
            <div className="dt-left-right">
              <span className="month">
                12 <sup>th</sup>
              </span>
            </div>
          </div>
          <div className="dt-right">
            <h3 className="event-name">Dussehra</h3>
            <p className="event-description">
              This day marks the victory of Lord Rama over the demon king
              Ravana, symbolizing the triumph of good over evil.
            </p>
          </div>
        </div>
        <div className="event-dt-dev">
          <div className="dt-left">
            <div className="dt-left-left">
              <span className="day">Oct</span>
              <span className="day">Thu</span>
            </div>
            <div className="dt-left-right">
              <span className="month">
                31 <sup>st</sup>
              </span>
            </div>
          </div>
          <div className="dt-right">
            <h3 className="event-name">Diwali</h3>
            <p className="event-description">
              The Hindu festival of lights, celebrated in various Indian regions
              with unique traditions.
            </p>
          </div>
        </div>
        <div className="event-dt-dev">
          <div className="dt-left">
            <div className="dt-left-left">
              <span className="day">Nov</span>
              <span className="day">Fri</span>
            </div>
            <div className="dt-left-right">
              <span className="month">
                3 <sup>rd</sup>
              </span>
            </div>
          </div>
          <div className="dt-right">
            <h3 className="event-name">Sports Day</h3>
            <p className="event-description">
              A day filled with athletic events and competitions.
            </p>
          </div>
        </div>
        <div className="event-dt-dev">
          <div className="dt-left">
            <div className="dt-left-left">
              <span className="day">Nov</span>
              <span className="day">Wed</span>
            </div>
            <div className="dt-left-right">
              <span className="month">
                15 <sup>th</sup>
              </span>
            </div>
          </div>
          <div className="dt-right">
            <h3 className="event-name">Children's Day</h3>
            <p className="event-description">
              Celebrating childhood with various activities and events.
            </p>
          </div>
        </div>
        <div className="event-dt-dev">
          <div className="dt-left">
            <div className="dt-left-left">
              <span className="day">Dec</span>
              <span className="day">Tue</span>
            </div>
            <div className="dt-left-right">
              <span className="month">
                25 <sup>th</sup>
              </span>
            </div>
          </div>
          <div className="dt-right">
            <h3 className="event-name">Christmas</h3>
            <p className="event-description">
              A festival celebrating the birth of Jesus Christ.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Eventlist;
